export default{tableHeader:"w_G3",isSortable:"w_G4",button:"w_G5",icon:"w_G6",sorted:"w_G7",dataTableHeader:"w_G8",left:"w_G9",right:"w_HA"};
